import React from "react";
import "./WidgetError.scss";
import { TextButton } from "@SeemplicityDev/shared";

export interface WidgetErrorProps {
  onWidgetsReload?: (() => void) | null;
}

const WidgetError: React.FC<WidgetErrorProps> = ({
  onWidgetsReload = null,
}) => (
  <div className={"widget-error"}>
    <i className={"seem-icon-error error-icon"} />
    <div>
      <span>Couldn't load data. </span>
      {!!onWidgetsReload && (
        <TextButton
          data-testid={"kpi-try-loading-again"}
          buttonStyle={"textLink"}
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            e.stopPropagation();
            onWidgetsReload?.();
          }}
          label={"Try again"}
          type="button"
        />
      )}
    </div>
  </div>
);

export default WidgetError;
